module.exports = __webpack_public_path__ + "img/1970East-022_WEB-min.90c33bb8.jpg";